// Fix for mini cart heading quantity not updating
(function() {
  'use strict';

  // Function to get translation from Shopify theme
  function getTranslation(key) {
    // Try to get translation from Shopify.theme.strings first
    if (Shopify && Shopify.theme && Shopify.theme.strings && Shopify.theme.strings[key]) {
      return Shopify.theme.strings[key];
    }
    
    // Fallback translations for common cart messages
    const translations = {
      'cart.general.empty': {
        'pt-BR': 'Seu carrinho está vazio.',
        'pt': 'Seu carrinho está vazio.',
        'es': 'Tu carrito en este momento está vacío.',
        'fr': 'Votre panier est actuellemnt vide.',
        'it': 'Il tuo carrello è vuoto',
        'de': 'Ihr Einkaufswagen ist momentan leer..',
        'en': 'Your cart is currently empty.'
      },
      'cart.general.continue': {
        'pt-BR': 'Continuar comprando',
        'pt': 'Continuar comprando',
        'es': 'Continuar comprando',
        'fr': 'Continer les achats',
        'it': 'Continua lo shopping',
        'de': 'Weiter einkaufen',
        'en': 'Continue Shopping'
      },
      'cart.general.checkout': {
        'pt-BR': 'Finalizar compra',
        'pt': 'Finalizar compra',
        'es': 'Finalizar compra',
        'fr': 'Finaliser la commande',
        'it': 'Finalizza l\'ordine',
        'de': 'Kaufen',
        'en': 'Checkout'
      },
    };
    
    // Get current language from Shopify or document
    let currentLang = 'en';
    if (Shopify && Shopify.locale) {
      currentLang = Shopify.locale;
    } else if (document.documentElement.lang) {
      currentLang = document.documentElement.lang;
    } else if (document.querySelector('html[lang]')) {
      currentLang = document.querySelector('html[lang]').getAttribute('lang');
    }
    
    // Extract language code (e.g., 'pt-BR' -> 'pt-BR', 'pt' -> 'pt')
    const langCode = currentLang.split('-')[0];
    const fullLangCode = currentLang;
    
    // Check if we have translations for this key
    if (translations[key]) {
      // Try full language code first (e.g., 'pt-BR')
      if (translations[key][fullLangCode]) {
        return translations[key][fullLangCode];
      }
      // Then try base language code (e.g., 'pt')
      if (translations[key][langCode]) {
        return translations[key][langCode];
      }
      // Fallback to English
      if (translations[key]['en']) {
        return translations[key]['en'];
      }
    }
    
    // Final fallback
    return key;
  }

  // Function to update mini cart heading span (singular/plural)
  function updateMiniCartHeading(itemCount) {
    const label = itemCount === 1 ? ' item' : ' items';
    document.querySelectorAll('#mini-cart .section-heading span').forEach(span => {
      if (span) {
        span.textContent = ' (' + itemCount + label + ')';
      }
    });
  }

  // Function to ensure mini cart remains visible when empty
  function ensureMiniCartVisibility() {
    const miniCartContainer = document.querySelector('#mini-cart');
    if (miniCartContainer) {
      // Ensure the mini cart container is always visible
      miniCartContainer.style.display = 'block';
      
      // Ensure the content wrapper is visible
      const contentWrapper = miniCartContainer.querySelector('.js-ajax-cart-content');
      if (contentWrapper) {
        contentWrapper.style.display = 'block';
      }
    }
  }

  // Function to handle empty cart state in mini cart
  function handleEmptyCartState() {
    const miniCartContainer = document.querySelector('#mini-cart');
    if (!miniCartContainer) return;

    const contentWrapper = miniCartContainer.querySelector('.js-ajax-cart-content');
    const cartForm = miniCartContainer.querySelector('.js-cart-form');
    const cartEmpty = miniCartContainer.querySelector('.js-cart-empty');

    // Prioridade: conteúdo já carregado pelo theme (evita piscar "empty" antes do updateView)
    const hasCartItemsInContent = contentWrapper && contentWrapper.querySelectorAll('.ajax-cart__cart-item').length > 0;
    if (hasCartItemsInContent) {
      if (cartForm) {
        cartForm.classList.remove('hide');
        cartForm.style.display = '';
      }
      if (cartEmpty) {
        cartEmpty.classList.add('hide');
        cartEmpty.style.display = 'none';
      }
      const countFromItems = contentWrapper.querySelectorAll('.ajax-cart__cart-item').length;
      updateMiniCartHeading(countFromItems);
      return;
    }

    // Só confiar no header count se o conteúdo já tiver sido preenchido (evita empty falso)
    const cartCountElements = document.querySelectorAll('.js-cart-count');
    let isCartEmpty = true;
    cartCountElements.forEach(countEl => {
      const count = parseInt(countEl.textContent, 10) || 0;
      if (count > 0) {
        isCartEmpty = false;
      }
    });

    if (isCartEmpty) {
      // Mostrar área de conteúdo (o theme adiciona .hide e limpa o HTML quando vazio)
      if (contentWrapper) {
        contentWrapper.classList.remove('hide');
        contentWrapper.style.display = '';
      }

      // Hide cart form if it exists
      if (cartForm) {
        cartForm.classList.add('hide');
        cartForm.style.display = 'none';
      }

      // Show empty cart message
      if (cartEmpty) {
        cartEmpty.classList.remove('hide');
        cartEmpty.style.display = 'block';
      } else {
        // Create empty cart message if it doesn't exist (theme limpou o conteúdo quando vazio)
        const emptyMessage = document.createElement('div');
        emptyMessage.className = 'ajax-cart__empty-cart a-center js-cart-empty';
        emptyMessage.innerHTML = `
          <p>${getTranslation('cart.general.empty')}</p>
          <a href="/collections/all" class="button button--primary">
            ${getTranslation('cart.general.continue')}
          </a>
        `;
        if (contentWrapper) {
          contentWrapper.appendChild(emptyMessage);
        }
      }

      // Update cart heading
      updateMiniCartHeading(0);
    } else {
      // Show cart form if it exists
      if (cartForm) {
        cartForm.classList.remove('hide');
        cartForm.style.display = 'block';
      }

      // Hide empty cart message
      if (cartEmpty) {
        cartEmpty.classList.add('hide');
        cartEmpty.style.display = 'none';
      }
    }
  }

  // Function to improve cart layout
  function improveCartLayout() {
    const cartDrawer = document.querySelector('.ajax-cart__drawer-wrapper');
    if (!cartDrawer) return;

    // Remove any HR elements from cart summary
    const hrElements = cartDrawer.querySelectorAll('hr');
    hrElements.forEach(hr => {
      hr.style.display = 'none';
    });

    // Ensure proper flex layout
    cartDrawer.style.display = 'flex';
    cartDrawer.style.flexDirection = 'column';
    cartDrawer.style.height = '100vh';
    cartDrawer.style.maxHeight = '100vh';

    // Find and style header
    const header = cartDrawer.querySelector('.ajax-cart__header-wrapper');
    if (header) {
      header.style.flexShrink = '0';
    }

    // Find and style form wrapper
    const formWrapper = cartDrawer.querySelector('.ajax-cart__form-wrapper');
    if (formWrapper) {
      formWrapper.style.flex = '1';
      formWrapper.style.overflowY = 'auto';
      formWrapper.style.display = 'flex';
      formWrapper.style.flexDirection = 'column';
    }

    // Find and style content wrapper
    const contentWrapper = cartDrawer.querySelector('.js-ajax-cart-content');
    if (contentWrapper) {
      contentWrapper.style.flex = '1';
      contentWrapper.style.overflowY = 'auto';
      contentWrapper.style.paddingBottom = '1rem';
    }

    // Find and style summary wrapper
    const summaryWrapper = cartDrawer.querySelector('.ajax-cart__summary-wrapper');
    if (summaryWrapper) {
      summaryWrapper.style.flexShrink = '0';
      summaryWrapper.style.marginTop = 'auto';
      summaryWrapper.style.borderTop = '1px solid #eee';
      summaryWrapper.style.paddingTop = '1rem';
      summaryWrapper.style.background = 'white';
    }

    // Find and style cart items
    const cartItems = cartDrawer.querySelector('.cart-items');
    if (cartItems) {
      cartItems.style.flex = '1';
      cartItems.style.overflowY = 'auto';
      cartItems.style.paddingBottom = '1rem';
    }

    // Find and style cart summary/total
    const cartSummary = cartDrawer.querySelector('.cart-summary, .cart-total');
    if (cartSummary) {
      cartSummary.style.position = 'sticky';
      cartSummary.style.bottom = '0';
      cartSummary.style.background = 'white';
      cartSummary.style.padding = '1rem 0';
      cartSummary.style.borderTop = '1px solid #eee';
      cartSummary.style.marginTop = 'auto';
    }
  }

  // Function to observe cart changes
  function observeCartChanges() {
    const miniCartContent = document.querySelector('#mini-cart .js-ajax-cart-content');

    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Contador do carrinho mudou
          const cartCountElements = document.querySelectorAll('.js-cart-count');
          cartCountElements.forEach(countEl => {
            if (mutation.target === countEl || countEl.contains(mutation.target)) {
              shouldUpdate = true;
            }
          });
          // Conteúdo do mini cart mudou (theme limpou ou injetou HTML) – mostrar vazio se precisar
          if (miniCartContent && (mutation.target === miniCartContent || miniCartContent.contains(mutation.target))) {
            shouldUpdate = true;
          }
        }
      });
      if (shouldUpdate) {
        handleEmptyCartState();
      }
    });

    // Observe cart count elements
    const cartCountElements = document.querySelectorAll('.js-cart-count');
    cartCountElements.forEach(countEl => {
      observer.observe(countEl, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });

    // Observar conteúdo do mini cart (quando o theme limpa ou atualiza, corrigir estado vazio)
    if (miniCartContent) {
      observer.observe(miniCartContent, {
        childList: true,
        subtree: true
      });
    }
  }

  // Function to handle cart drawer opening
  function handleCartDrawerOpen() {
    // Hide loader when drawer opens (fix for opening via icon without add-to-cart flow)
    const loader = document.querySelector('.ajax-cart__drawer-wrapper .js-mini-cart-loader');
    if (loader) {
      loader.style.opacity = '0';
      loader.style.pointerEvents = 'none';
      loader.style.display = 'none';
    }
    // Ensure content area is visible
    const contentWrapper = document.querySelector('.ajax-cart__drawer-wrapper .js-ajax-cart-content');
    if (contentWrapper) {
      contentWrapper.classList.remove('hide');
      contentWrapper.style.display = '';
    }
    // Depois do theme fazer getCart → updateView, garantir estado vazio (mensagem + botão) se carrinho vazio
    setTimeout(function() {
      handleEmptyCartState();
    }, 500);
  }

  // Add CSS to ensure mini cart visibility
  function addMiniCartCSS() {
    const style = document.createElement('style');
    style.textContent = `
      #mini-cart {
        display: block !important;
      }
      
      #mini-cart .js-ajax-cart-content {
        display: block !important;
      }

      /* Empty cart message styling */
      .ajax-cart__empty-cart {
        text-align: center;
        padding: 2rem 1rem;
        color: #666;
      }

      .ajax-cart__empty-cart p {
        font-size: 1.1rem;
        margin-bottom: 1.5rem;
        color: #333;
      }

      .ajax-cart__empty-cart .button {
        display: inline-block;
        padding: 0.75rem 1.5rem;
        background: #6a1b9a;
        color: white;
        text-decoration: none;
        border-radius: 4px;
        transition: background-color 0.3s ease;
      }

      .ajax-cart__empty-cart .button:hover {
        background: #4a148c;
      }

      /* Ensure product modals work correctly when moved to body */
      .product-modal {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: 99999 !important;
        background: rgba(0, 0, 0, 0.5) !important;
        display: none;
        align-items: center;
        justify-content: center;
      }

      .product-modal[style*="display: block"] {
        display: flex !important;
      }

      /* Ensure modal content is properly positioned */
      .product-modal > * {
        max-width: 90vw;
        max-height: 90vh;
        overflow-y: auto;
        background: white;
        border-radius: 8px;
        padding: 20px;
        position: relative;
      }
    `;
    document.head.appendChild(style);
  }

  // Function to fix quantity adjustment for items with same product ID but different selling plans
  function fixQuantityAdjustment() {
    // Override the original adjustQty function to handle selling plans correctly
    if (Shopify && Shopify.theme && Shopify.theme.ajaxCart && Shopify.theme.ajaxCart.adjustQty) {
      const originalAdjustQty = Shopify.theme.ajaxCart.adjustQty;
      
      Shopify.theme.ajaxCart.adjustQty = function(value, itemId, config) {
        // Get all elements with this itemId
        const allElements = document.querySelectorAll('.item_' + itemId);
        
        if (allElements.length <= 1) {
          // If there's only one element, use original behavior
          return originalAdjustQty.call(this, value, itemId, config);
        }
        
        // If there are multiple elements, find the one that was most recently clicked
        let targetElement = null;
        let latestClickTime = 0;
        
        // Find the element with the most recent click
        for (let element of allElements) {
          const clickTime = element.getAttribute('data-last-clicked');
          if (clickTime && parseInt(clickTime) > latestClickTime) {
            latestClickTime = parseInt(clickTime);
            targetElement = element;
          }
        }
        
        // If we found a recently clicked element, use it
        if (targetElement && (Date.now() - latestClickTime) < 1000) { // Within last second
          const elementInput = targetElement.querySelector('.updates_' + itemId);
          if (elementInput) {
            const key = elementInput.dataset.itemKey;
            const max = elementInput.dataset.limit;
            const quantity = parseInt(elementInput.value) + parseInt(value);

            // Check limit to prevent over adding
            if (Shopify.theme.ajaxCart.checkLimit(max, quantity, targetElement, config)) return false;

            // Check new qty to prevent going lower than 1
            if (quantity === 0) return false;

            // Set new quantity
            elementInput.value = quantity;

            // Adjust cart object
            setTimeout(function() {
              Shopify.theme.cart.updateItem(key, { quantity }).then(state => {
                Shopify.theme.ajaxCart.updateView(config, state);
              });
            }, 250);
            
            return true;
          }
        }
        
        // Fallback: try to find the element that was clicked by checking the event path
        if (event && event.target) {
          for (let element of allElements) {
            if (element.contains(event.target)) {
              targetElement = element;
              break;
            }
          }
        }
        
        // If we still can't find it, try to find the element that has focus
        if (!targetElement) {
          for (let element of allElements) {
            const input = element.querySelector('.updates_' + itemId);
            if (input && input === document.activeElement) {
              targetElement = element;
              break;
            }
          }
        }
        
        // If we found a specific target element, update only that one
        if (targetElement) {
          const elementInput = targetElement.querySelector('.updates_' + itemId);
          if (elementInput) {
            const key = elementInput.dataset.itemKey;
            const max = elementInput.dataset.limit;
            const quantity = parseInt(elementInput.value) + parseInt(value);

            // Check limit to prevent over adding
            if (Shopify.theme.ajaxCart.checkLimit(max, quantity, targetElement, config)) return false;

            // Check new qty to prevent going lower than 1
            if (quantity === 0) return false;

            // Set new quantity
            elementInput.value = quantity;

            // Adjust cart object
            setTimeout(function() {
              Shopify.theme.cart.updateItem(key, { quantity }).then(state => {
                Shopify.theme.ajaxCart.updateView(config, state);
              });
            }, 250);
            
            return true;
          }
        }
        
        // Fallback to original behavior if we can't determine which element to update
        return originalAdjustQty.call(this, value, itemId, config);
      };
    }
    
    // Also intercept clicks on quantity buttons to ensure we track which item was clicked
    document.addEventListener('click', function(event) {
      // Check if this is a quantity adjustment button
      if (event.target.matches('.js-qty__adjust, .qty__adjust, [data-qty-adjust]')) {
        const button = event.target;
        const lineItem = button.closest('[class*="item_"]');
        
        if (lineItem) {
          // Store the clicked element in a data attribute for later reference
          lineItem.setAttribute('data-last-clicked', Date.now());
          
          // Remove the attribute from other items with the same itemId
          const itemId = lineItem.className.match(/item_(\d+)/);
          if (itemId && itemId[1]) {
            const otherItems = document.querySelectorAll('.item_' + itemId[1]);
            otherItems.forEach(item => {
              if (item !== lineItem) {
                item.removeAttribute('data-last-clicked');
              }
            });
          }
        }
      }
    }, true); // Use capture phase to intercept before other handlers
  }

  // Function to move product modals to the end of body
  function moveProductModalsToBody() {
    // Find all product modals
    const productModals = document.querySelectorAll('.product-modal');
    
    if (productModals.length > 0) {
      productModals.forEach(modal => {
        // Only move if not already at the end of body
        if (modal.parentNode !== document.body || modal.nextSibling !== null) {
          // Store the modal ID for reference
          const modalId = modal.id;
          
          // Move to the end of body
          document.body.appendChild(modal);
          
          // Ensure the modal has an ID for reference
          if (modalId) {
            modal.id = modalId;
          }
          
          // Update any buttons that reference this modal
          updateModalReferences(modal);
        }
      });
      
      console.log(`Moved ${productModals.length} product modals to body`);
    }
  }

  // Function to update modal references in buttons
  function updateModalReferences(modal) {
    const modalId = modal.id;
    
    if (!modalId) return;
    
    // Find all buttons that should open this modal
    const buttons = document.querySelectorAll(`[data-modal-target="${modalId}"], [href="#${modalId}"], [onclick*="${modalId}"]`);
    
    buttons.forEach(button => {
      // Ensure the button can still reference the modal
      if (button.hasAttribute('data-modal-target')) {
        button.setAttribute('data-modal-target', modalId);
      }
      
      // Update href if it exists
      if (button.hasAttribute('href') && button.getAttribute('href').includes(modalId)) {
        button.setAttribute('href', `#${modalId}`);
      }
    });
  }

  // Function to ensure modals are accessible after being moved
  function ensureModalAccessibility() {
    // Listen for clicks on modal trigger buttons
    document.addEventListener('click', function(event) {
      const button = event.target.closest('[data-modal-target], [href^="#"], .js-open-modal');
      
      if (button) {
        let modalId = null;
        
        // Get modal ID from different possible attributes
        if (button.hasAttribute('data-modal-target')) {
          modalId = button.getAttribute('data-modal-target');
        } else if (button.hasAttribute('href') && button.getAttribute('href').startsWith('#')) {
          modalId = button.getAttribute('href').substring(1);
        }
        
        if (modalId) {
          const modal = document.getElementById(modalId);
          // Only theme product modals. Hash links like #shopify-section-… are in-page anchors.
          if (modal && modal.matches('.product-modal, .purple-tree-modal')) {
            // Ensure modal is visible and properly positioned
            modal.style.display = 'block';
            modal.style.position = 'fixed';
            modal.style.top = '0';
            modal.style.left = '0';
            modal.style.width = '100vw';
            modal.style.height = '100vh';
            modal.style.zIndex = '9999';
            modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            
            // Add event listener to close modal when clicking outside
            const closeModal = function(e) {
              if (e.target === modal) {
                modal.style.display = 'none';
                modal.removeEventListener('click', closeModal);
              }
            };
            
            modal.addEventListener('click', closeModal);
            
            // Add escape key listener
            const escapeHandler = function(e) {
              if (e.key === 'Escape') {
                modal.style.display = 'none';
                document.removeEventListener('keydown', escapeHandler);
              }
            };
            
            document.addEventListener('keydown', escapeHandler);
          }
        }
      }
    });
  }

  // Override the original updateView function to include mini cart heading updates
  if (Shopify && Shopify.theme && Shopify.theme.ajaxCart && Shopify.theme.ajaxCart.updateView) {
    const originalUpdateView = Shopify.theme.ajaxCart.updateView;
    
    Shopify.theme.ajaxCart.updateView = function(config, Cart) {
      // Call the original function
      originalUpdateView.call(this, config, Cart);
      
      // Update mini cart heading
      if (Cart && Cart.item_count !== undefined) {
        updateMiniCartHeading(Cart.item_count);
      }
      
      // Ensure mini cart visibility
      ensureMiniCartVisibility();
    };
  }

  // Listen for cart update events
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      updateMiniCartHeading(event.detail.cart.item_count);
      ensureMiniCartVisibility();
      handleEmptyCartState();
      // Apply layout improvements after cart update
      setTimeout(() => {
        improveCartLayout();
      }, 100);
    }
  });

  // Monitor cart count elements for changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const cartCountElements = document.querySelectorAll('.js-cart-count');
        cartCountElements.forEach(function(element) {
          const itemCount = element.textContent;
          if (itemCount && !isNaN(parseInt(itemCount))) {
            updateMiniCartHeading(parseInt(itemCount));
            handleEmptyCartState();
            // Apply layout improvements after count change
            setTimeout(() => {
              improveCartLayout();
            }, 50);
          }
        });
      }
    });
  });

  // Start observing cart count elements
  function startObserving() {
    const cartCountElements = document.querySelectorAll('.js-cart-count');
    cartCountElements.forEach(function(element) {
      observer.observe(element, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  function fixFlickity() {
    setTimeout(() => {
    document.querySelectorAll('.sls-option-container').forEach(btn => {
      btn.addEventListener('click', () => {
          const carouselElement = document.querySelector('.flickity-slider')?.closest('.flickity-enabled');
    
          if (carouselElement && $(carouselElement).data('flickity')) {
            console.log('🔧 Forçando resize do Flickity');
            const flkty = $(carouselElement).data('flickity');
            flkty.reloadCells();
          } else {
            console.warn('Flickity não encontrado.');
          }
        });
      });
    }, 1000);
  }

  // Initialize fixes when DOM is ready
  function init() {
    fixQuantityAdjustment();
    moveProductModalsToBody();
    ensureModalAccessibility();
    startObserving();
    fixFlickity();
    
    // Initialize empty cart handling
    handleEmptyCartState();
    observeCartChanges();
    
    // Apply cart layout improvements
    improveCartLayout();
    
    // Listen for cart drawer opening
    document.addEventListener('click', function(event) {
      const cartTrigger = event.target.closest('[data-wau-slideout-target="ajax-cart"], .js-mini-cart-trigger');
      if (cartTrigger) {
        handleCartDrawerOpen();
        // Apply layout improvements when cart opens
        setTimeout(() => {
          improveCartLayout();
        }, 100);
      }
    });
    
    // Also observe for dynamically added cart count elements
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              const newCartCounts = node.querySelectorAll ? node.querySelectorAll('.js-cart-count') : [];
              newCartCounts.forEach(function(element) {
                observer.observe(element, {
                  childList: true,
                  characterData: true,
                  subtree: true
                });
              });
              
              // Check if cart drawer was added
              if (node.classList && node.classList.contains('ajax-cart__drawer-wrapper')) {
                setTimeout(() => {
                  improveCartLayout();
                }, 50);
              }
            }
          });
        }
      });
    });
    
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also listen for add to cart events
  document.addEventListener('cart:added', function(event) {
    if (event.detail && event.detail.cart) {
      updateMiniCartHeading(event.detail.cart.item_count);
      ensureMiniCartVisibility();
      handleEmptyCartState();
      // Apply layout improvements after adding to cart
      setTimeout(() => {
        improveCartLayout();
      }, 100);
    }
  });

  // Also run on window load to catch any late updates
  window.addEventListener('load', function() {
    addMiniCartCSS();
    ensureMiniCartVisibility();
    handleEmptyCartState();
    // Apply layout improvements on window load
    setTimeout(() => {
      improveCartLayout();
    }, 200);
  });

})(); 